export default __webpack_public_path__ + "static/media/gnl2.865f28e1.webp";